var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as _ from 'lodash';
import renderComponent from './renderComponent';
// TODO @Bugaa92: deprecated by createComponent.tsx
var UIComponent = /** @class */ (function (_super) {
    __extends(UIComponent, _super);
    function UIComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.childClass = _this.constructor;
        _this.setFocusZoneRef = function (focusZone) {
            _this.focusZone = focusZone;
        };
        if (process.env.NODE_ENV !== 'production') {
            var child = _this.constructor;
            var childName = child.name;
            if (typeof _this.renderComponent !== 'function') {
                throw new Error(childName + " extending UIComponent is missing a renderComponent() method.");
            }
        }
        _this.renderComponent = _this.renderComponent.bind(_this);
        return _this;
    }
    Object.defineProperty(UIComponent, "handledProps", {
        get: function () {
            if (!this._handledPropsCache) {
                this._handledPropsCache = _.difference(_.keys(this.propTypes), this.unhandledProps).sort();
            }
            return this._handledPropsCache;
        },
        enumerable: true,
        configurable: true
    });
    UIComponent.prototype.renderComponent = function (config) {
        throw new Error('renderComponent is not implemented.');
    };
    UIComponent.prototype.render = function () {
        return renderComponent({
            className: this.childClass.className,
            defaultProps: this.childClass.defaultProps,
            displayName: this.childClass.displayName,
            handledProps: this.childClass.handledProps,
            props: this.props,
            state: this.state,
            actionHandlers: this.actionHandlers,
            focusZoneRef: this.setFocusZoneRef,
            render: this.renderComponent,
        });
    };
    /** Array of props to exclude from list of handled ones. */
    UIComponent.unhandledProps = [];
    UIComponent._handledPropsCache = undefined;
    return UIComponent;
}(React.Component));
export default UIComponent;
